import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface RecentSearchEntry {
  label: string;
  path: string;
  icon: string;
  crumb: string[];
  description?: string;
  queryParams?: { [key: string]: string };
}

const RECENT_STORAGE_KEY = "dashy-global-search-recent";
const RECENT_MAX = 6;

/** Open/close state + recent history for the Ctrl/Cmd+K command palette. */
@Injectable({ providedIn: "root" })
export class GlobalSearchService {
  private openSubject = new BehaviorSubject<boolean>(false);
  readonly open$ = this.openSubject.asObservable();

  get isOpen(): boolean {
    return this.openSubject.value;
  }

  open(): void {
    this.openSubject.next(true);
  }

  close(): void {
    this.openSubject.next(false);
  }

  toggle(): void {
    this.openSubject.next(!this.openSubject.value);
  }

  getRecent(): RecentSearchEntry[] {
    try {
      const raw = localStorage.getItem(RECENT_STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.slice(0, RECENT_MAX) : [];
    } catch {
      return [];
    }
  }

  addRecent(entry: RecentSearchEntry): void {
    try {
      const list = this.getRecent().filter(
        (item) =>
          item.path !== entry.path ||
          JSON.stringify(item.queryParams || {}) !==
            JSON.stringify(entry.queryParams || {}),
      );
      list.unshift(entry);
      localStorage.setItem(
        RECENT_STORAGE_KEY,
        JSON.stringify(list.slice(0, RECENT_MAX)),
      );
    } catch {
      // storage unavailable — recents are best-effort
    }
  }

  clearRecent(): void {
    try {
      localStorage.removeItem(RECENT_STORAGE_KEY);
    } catch {
      // ignore
    }
  }
}
